import * as React from 'react';
import {
  useSetMatchAvailabilityMutation,
  AvailabilityStatus,
} from '../generated/graphql';
import { useAlert } from '../contexts/AlertContext';
import { useAnalytics } from '../contexts/AnalyticsContext';

interface Props {
  currentAvailabililty: AvailabilityStatus;
  playerId: string;
  matchId: string;
}

/**
 * Hook for optimistically handling match availability choice.
 * Will immediately select the chosen availability and update the server in
 * the background. If a failure occurs will revert the choice and show an
 * error message.
 * @param param0
 */
export const useChooseAvailability = ({
  currentAvailabililty,
  playerId,
  matchId,
}: Props) => {
  const [chosenAvailability, setChosenAvailability] =
    React.useState(currentAvailabililty);

  const [, setAvailability] = useSetMatchAvailabilityMutation();
  const alert = useAlert();
  const analytics = useAnalytics();

  const chooseAvailability = (newAvailability: AvailabilityStatus) => {
    const previousAvailability = chosenAvailability;
    setChosenAvailability(newAvailability);
    return setAvailability({
      input: { status: newAvailability, playerId, matchId },
    }).then((res) => {
      if (res.data?.setMatchAvailability?.validation || res.error) {
        setChosenAvailability(previousAvailability);
        alert('Something went wrong. Try again later.', 'danger');

        analytics.track('Data Submit Failed', {
          form: 'availability',
          errors: res.data?.setMatchAvailability?.validation,
        });
      }

      if (res.data?.setMatchAvailability?.entity) {
        analytics.track('Data Submit Succeeded', {
          form: 'availability',
        });
      }
    });
  };

  return [chosenAvailability, chooseAvailability] as const;
};
